export default {
	bodyScrollAdd() {
		document.body.style.marginRight = `0`;
		document.body.classList.remove('blocked-scroll');
	},

	bodyScrollRemove() {
		document.body.style.marginRight = `${window.innerWidth - document.documentElement.clientWidth}px`;
		document.body.classList.add('blocked-scroll');
	}
};
